import { HOSTED_RUNTIME_LABEL } from '@/core/const/hostedRuntimeLabel.const'
import { Runtime } from '@/core/enums/runtime.enum'

import { formatRuntimePhrase } from './formatRuntimePhrase'

export const formatHostedRuntimeTooltip = (runtimeName: Runtime, runtimeVersion?: string): string => {
  const version = runtimeVersion?.trim()
  if (!version) {
    const label = HOSTED_RUNTIME_LABEL[runtimeName] ?? runtimeName
    return `Running on ${label} runtime`
  }

  return `Running on ${formatRuntimePhrase(runtimeName, version)} runtime`
}
